import { Box, Button, DialogActions, DialogContent, Stack, TextField } from "@mui/material";
import Translate from "../../utils/Translate";
import ButtonWithSpinner from "../ButtonWithSpinner";
import { useState } from "react";
import { useApi } from "../../utils/Api";
import { useSnackbar } from "notistack";

export default function DigitalLicenseToStudentDialog({ digitalLicenseId, sendAsPdf }) {
  const api = useApi();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const message = !sendAsPdf
    ? Translate.get("SendDigitalLicenseToStudentQuestion")
    : Translate.get("SendDigitalLicenseAsPdfToStudentQuestion");

  async function sendDigitalLicenseToStudent() {
    const response = await api.fetch(
      `${import.meta.env.VITE_MAIN_URL}digital/licenses/${digitalLicenseId}/send-to-student`,
      true,
      "POST",
    );
    if (response && response.isSuccessful) {
      const successMessage = enqueueSnackbar(Translate.get("Ready"), {
        variant: "success",
        autoHideDuration: 6000,
        onClick: () => closeSnackbar(successMessage),
      });
      window.history.back();
    }
  }

  return (
    <>
      <DialogContent>
        <Box>{message}</Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => window.history.back()}>{Translate.get("Cancel")}</Button>
        <ButtonWithSpinner variant="contained" onClick={sendDigitalLicenseToStudent}>
          {Translate.get("Send")}
        </ButtonWithSpinner>
      </DialogActions>
    </>
  );
}
